import _pick from "lodash/pick";
import _isFunction from "lodash/isFunction";
export default function createMapperFunc(mappingConfig) {
  if (_isFunction(mappingConfig)) return mappingConfig;
  return function map(values) {
    return _pick(values, mappingConfig);
  };
}